export enum TabTypes {
  Default = 'default',
  Select = 'select',
}

export enum TabSizes {
  L = 'l',
  M = 'm',
  S = 's',
}
